export default "__VITE_ASSET__DJeWUkmc__"